interface ValidationData {
    email?: string
    phone?: string
}

interface ValidationErrors {
    email?: string
    phone?: string
}

function isDigit(char: string): boolean {
    const code = char.charCodeAt(0)
    return (code >= 48 && code <= 57) || code == 43 // '0' - '9', '+'
}

export function filterDigits(value: string): string {
    let result = ''
    for (let i = 0; i < value.length; i++) {
        if (isDigit(value[i])) {
            result += value[i]
        }
    }
    return result.substring(0, 12)
}
export function validatePhone(
    data: ValidationData,
    errors: ValidationErrors,
    event: Event
): void {
    const target = event.target

    if (!(target instanceof HTMLInputElement)) return

    const filteredValue = filterDigits(target.value)
    data.phone = filteredValue
    target.value = filteredValue

    if (!filteredValue) {
        errors.phone = 'Телефон обязателен для заполнения'
    } else {
        errors.phone = ''
    }
}
export function validateEmail(
    data: ValidationData,
    errors: ValidationErrors
): void {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!data.email) {
        errors.email = 'Email обязателен для заполнения'
    } else if (!emailRegex.test(data.email)) {
        errors.email = 'Введите корректный email адрес'
    } else {
        errors.email = ''
    }
}
